import { render } from "./GameOptionsView.vue?vue&type=template&id=c63e4142"
import script from "./GameOptionsView.vue?vue&type=script&lang=js"
export * from "./GameOptionsView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/rastemo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__